import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setAuthToken, apiErr } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=logged out, obj=logged in
  const hasToken = !!localStorage.getItem("dsa_token");

  useEffect(() => {
    if (!hasToken) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        setAuthToken(null);
        setUser(false);
      });
  }, [hasToken]);

  const login = useCallback(async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setAuthToken(r.data.token);
    setUser(r.data.user);
    return r.data.user;
  }, []);

  const logout = useCallback(() => {
    setAuthToken(null);
    setUser(false);
  }, []);

  const refreshMe = useCallback(async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
  }, []);

  const has = useCallback(
    (perm) => user && (user.role === "admin" || (user.permissions || []).includes(perm)),
    [user]
  );

  return (
    <AuthContext.Provider value={{ user, login, logout, refreshMe, has, apiErr }}>
      {children}
    </AuthContext.Provider>
  );
}
